import XAPPService from "app/Core/services/XAPPService";
import { GETCUSTOM_TAG_FUNCIONALIDADE, TagFuncionalidadeListState } from "app/ERP/TagFuncionalidade/Store/Actions/TagFuncionalidadeActions";
import _ from "lodash";

export const CUSTOMCRMFORM_TAGS = "[CUSTOMCRMFORM APP] TAGS";
export const CUSTOMCRMFORM_WARNING = "[CUSTOMCRMFORM APP] WARNING";
export const CUSTOMCRMFORM_INFO = "[CUSTOMCRMFORM APP] INFO";
export const CUSTOMCRMFORM_ERROR = "[CUSTOMCRMFORM APP] ERROR";

export function save(_AValue, _AParams) {
    return (dispatch) => {
        var AActions = [];

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "DadosCrm", "ATUALIZAR-DADOS-CRM", _AValue, "", [], [], 1);

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactionpessoaformulario", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    dispatch({
                        type: CUSTOMCRMFORM_WARNING,
                        payload: response.warning
                    });
                }
                else if (response.info) {
                    dispatch({
                        type: CUSTOMCRMFORM_INFO,
                        payload: response.info
                    });
                }
            }).catch(error => {
                return dispatch({
                    type: CUSTOMCRMFORM_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AParams) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AActions = [];

        AConditionsAND = [{ "Campo": "tagfuncionalidade.tipo", "Operador": "=", "Valor": "pessoa" }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "tagfuncionalidade", AActions, "spvwtagfuncionalidade", TagFuncionalidadeListState, "SELECIONAR", AConditionsAND, []);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GETCUSTOM_TAG_FUNCIONALIDADE,
                        Name: "pessoa",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                ])
            ).catch(error => {
                return dispatch({
                    type: CUSTOMCRMFORM_ERROR,
                    payload: error
                });
            });
    };
}